var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[(!_vm.$store.state.authorized)?_c('div',[_c('h1',{staticClass:"mb-4"},[_vm._v("Create Account")]),_c('CreateAccount')],1):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }